import {
  Blocks,
  LayoutList,
  ListPlusIcon,
  SlidersHorizontal,
} from "lucide-react";
import { BlurImage } from "../components/animations/blur-image";
import { WobbleCard } from "../components/animations/wobble-card";

export const ImageContainer = ({ children }) => {
  return (
    <div className="relative">
      <div className="absolute top-0 w-full h-px inset-x-0 bg-gradient-to-r from-transparent via-fuchsia-300 to-transparent" />
      <div className="absolute top-0 w-40 mx-auto h-px inset-x-10 bg-gradient-to-r from-transparent via-fuchsia-800 to-transparent" />
      <WobbleCard containerClassName="border-0" className="relative">
        {children}
      </WobbleCard>
      <div className="absolute bottom-0 w-full h-px inset-x-0 bg-gradient-to-r from-transparent via-fuchsia-300 to-transparent" />
      <div className="absolute bottom-0 w-40 mx-auto h-px inset-x-10 bg-gradient-to-r from-transparent via-fuchsia-800 to-transparent" />
    </div>
  );
};

export const tools = [
  {
    icon: <ListPlusIcon className="size-20 text-fuchsia-700" />,
    title: "New Product Form",
    description:
      "Effortlessly create new products with our intuitive and user-friendly setup form.",
    content: (
      <ImageContainer>
        <BlurImage
          src={
            window.siteUrl +
            "/wp-content/plugins/innovative-design/public/images/WHIZMANAGE_1.jpg"
          }
          alt="dashboard"
          className="w-full rounded-3xl"
        />
      </ImageContainer>
    ),
  },
  {
    icon: <SlidersHorizontal className="size-20 text-fuchsia-700" />,
    title: "Bulk Product Editing",
    description:
      "Edit, update, and manage your entire product table quickly and efficiently, just like an Excel spreadsheet.",
    content: (
      <ImageContainer>
        <BlurImage
          src={
            window.siteUrl +
            "/wp-content/plugins/innovative-design/public/images/WHIZMANAGE_2.jpg"
          }
          alt="dashboard"
          className="w-full rounded-3xl"
        />
      </ImageContainer>
    ),
  },
  {
    icon: <LayoutList className="size-20 text-fuchsia-700" />,
    title: "Powerful Coupon Manager",
    description:
      "Effortlessly control your store's discount strategy with our elegant and comprehensive coupon management system.",
    content: (
      <ImageContainer>
        <BlurImage
          src={
            window.siteUrl +
            "/wp-content/plugins/innovative-design/public/images/WHIZMANAGE_5.png"
          }
          alt="dashboard"
          className="w-full rounded-3xl"
        />
      </ImageContainer>
    ),
  },
  {
    icon: <Blocks className="size-20 text-fuchsia-700" />,
    title: "Product Variations",
    description:
      "Add and edit product variations with ease, including complex combinations of product attributes.",
    content: (
      <ImageContainer>
        <BlurImage
          src={
            window.siteUrl +
            "/wp-content/plugins/innovative-design/public/images/WHIZMANAGE_4.jpg"
          }
          alt="dashboard"
          className="w-full rounded-3xl"
        />
      </ImageContainer>
    ),
  },
];
